export default __webpack_public_path__ + "static/media/A3.e2020386.png";